import { toast } from "react-toastify";
import store from "redux/store";
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_RATECALCULATION } from "resources/actionTypes";
import { onLoaderTrigger } from "redux/actions/commonAction";
import { rateCalculationApi } from "services/RateCalculationService";


function* fetchRateCalculation(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const userRateCalculation = yield call(
    rateCalculationApi,
    payload
  );
  if (userRateCalculation?.success) {
    yield put({ type: GET_RATECALCULATION.GET_RATECALCULATION_SUCCESS, userRateCalculation: userRateCalculation });
    toast.success(userRateCalculation.message);
    store.dispatch(onLoaderTrigger(false));
  } else {
    yield put({
      type: GET_RATECALCULATION.GET_RATECALCULATION_FAILED,
      message: userRateCalculation.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(userRateCalculation.message);
  }
}

export function* rateCalculationSaga() {
  yield takeEvery(GET_RATECALCULATION.GET_RATECALCULATION_REQUESTED, fetchRateCalculation);
}